import { OnChanges, Input, SimpleChanges, Component } from '@angular/core';

@Component({
  selector: 'mac-user-avatar',
  standalone: false,
  template: `<mac-avatar [text]="text" />`,
})
export class UserAvatarComponent implements OnChanges {
  @Input() firstName?: string | null | undefined;
  @Input() lastName?: string | null | undefined;
  @Input() email?: string | null | undefined;

  text: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    this.setText();
  }

  setText(): void {
    if (this.firstName && this.lastName) {
      // Use the user initials
      this.text = this.firstName[0] + this.lastName[0];
    } else if (this.email) {
      // Use the first two letters of the email
      // This is a fallback for when the user has no first name or last name
      this.text = this.email.slice(0, Math.min(this.email?.length, 2));
    } else {
      this.text = '';
    }
  }
}
